global.Headroom = require('headroom.js');
require('../../../node_modules/headroom.js/dist/jQuery.headroom.min.js');
const GA = require('./ga');

let openClass = 'ec-main-menu--open';
let headerSelector = 'header';

$(document).ready(function () {
    $(headerSelector).headroom({
        offset: 250,
        tolerance: {
            up: 7,
            down: 10
        },
        onUnpin: function () {
            $(headerSelector).removeClass(openClass);
        }
    });

    $('.ec-js-open-menu-button').on('click', function () {
        const $header = $(this).parents(headerSelector);

        $header.toggleClass(openClass);

        const open = $header.hasClass(openClass);

        GA.event('menu', open ? 'open' : 'close', 'Toggle the main menu');
    });
});